import React from 'react';

function Pee () {
    return (
        <div>
            <p>Paper EE</p>
            <div class="row">
                        <div class="col">
                            <ul className='left__side__list'>
                                <li>
                                  <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i class="fa-solid fa-book fa"></i> <br/> 1st Year </div>  </button> </a> 
                                </li>
                            </ul>
                        </div>
                        
                        <div className='col'>
                            <ul className='left__side__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> 2nd Year </div> </button> </a>
                                </li>
                            </ul>
                        </div>
                        <div className='col'>
                            <ul className='left__side__list'>   
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class='far fa-sticky-note fa'></i>  <br/>
                                   3rd Year </div> </button> </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list upload__items diagonal-hoverrr'>  <div className='contenttt'> <i class="fa-solid fa-share fa"></i> <br/> 4th </div> </button> </a>
                                </li>
                            </ul>
                        </div>

                    </div>
        </div>
    );
}

export default Pee;
